"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChrome = exports.isMobile = exports.isAndroid = exports.isIos = void 0;
function isIos() {
    return navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)/i) !== null;
}
exports.isIos = isIos;
function isAndroid() {
    return navigator.userAgent.match(/(android)/i) !== null;
}
exports.isAndroid = isAndroid;
function isMobile() {
    return navigator.userAgent.toLowerCase().match(/mobile/i) !== null;
}
exports.isMobile = isMobile;
function isChrome() {
    return navigator.userAgent.toLowerCase().indexOf('chrome') >= 0;
}
exports.isChrome = isChrome;
